import styled from "styled-components";

// These form styles are scoped to the seller signup steps.
export const FieldStack = styled.div`
  display: grid;
  gap: var(--space-6);
  min-width: 0;
`;

export const Field = styled.div`
  display: grid;
  gap: var(--space-2);
  min-width: 0;
`;

export const FieldLabel = styled.label`
  display: block;
  color: var(--color-text-primary);
  font-size: var(--text-body-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-body-lg);
`;

export const Required = styled.span`
  color: var(--color-text-danger);
`;

export const HelperText = styled.p`
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--text-caption);
  line-height: var(--leading-body);
  word-break: keep-all;
  overflow-wrap: anywhere;
`;

export const FormInput = styled.input`
  width: 100%;
  min-width: 0;
  height: var(--control-lg);
  padding: 0 var(--space-4);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-family: var(--font-family-base);
  &&& { font-size: var(--text-body-lg); line-height: var(--leading-body-lg); }
  &:focus-visible {
    border-color: var(--color-brand);
    box-shadow: var(--shadow-focus);
  }
  &:disabled {
    background: var(--color-bg-muted);
    color: var(--color-text-secondary);
  }
  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] { -moz-appearance: textfield; }
`;

export const ControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
  > input { flex: 1; }
`;

export const ActionButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: var(--control-lg);
  padding: 0 var(--space-4);
  border: 0;
  border-radius: var(--radius-md);
  background: var(--gradient-brand);
  color: var(--color-text-on-brand);
  &&& { font-size: var(--text-body-lg); }
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  cursor: pointer;
  &:hover { background: var(--gradient-brand-hover); }
  &:disabled {
    background: var(--color-bg-muted);
    color: var(--color-text-disabled);
    cursor: not-allowed;
  }
`;
